import { cn } from '@/lib/utils';

import Button from '@/components/atoms/Button';

import iconXCloseSrc from '~/icons/x-close.svg';
import { SvgIcon } from '@/components/SvgIcon';

export const ModalCloseButton = ({
  classNames,
  handleClose,
}: {
  classNames?: {
    close?: string;
    closeCross?: string;
  };
  handleClose: () => void;
}) => (
  <Button
    onClick={handleClose}
    classNames={{
      root: cn(
        'absolute right-4 h-10 w-10 top-4 text-gray-500 hover:bg-gray-50 active:bg-gray-200',
        classNames?.close
      ),
    }}
    slim
    variant='text'
    color='secondary'
    data-tracker-context='modal-close'
  >
    <SvgIcon src={iconXCloseSrc} className={cn('h-4 w-4', classNames?.closeCross)} />
  </Button>
);
